import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
  Box,
  TextField,
  Checkbox,
  FormControlLabel,
  Paper,
} from '@mui/material';
import { Check } from '@mui/icons-material';
import axios from 'axios';
import utils from '../../../utils';

const messageTexts = [
  'Controllo se il token è ancora valido...',
  'Effettuo il login (potrebbe richiedere qualche minuto)...',
  'Controllo la presenza dell\'anagrafica...',
  'Inserisco l\'anagrafica...'
];

const DialogCp = ({ open, onClose, idAssunzione }) => {
  const [loading, setLoading] = React.useState(false);
  const [messages, setMessages] = React.useState([]);
  const [completed, setCompleted] = React.useState([]);
  const [missingFields, setMissingFields] = React.useState([]);
  const [formData, setFormData] = React.useState({});

  const [statusMessage, setStatusMessage] = React.useState('');
  const [isError, setIsError] = React.useState(false);

  const closeWithError = (err) => {
    setLoading(false);
    setIsError(true);
    setStatusMessage(err);
  }

  const handleInsertAnagrafica = async () => {
    setStatusMessage('');
    setLoading(true);
    setMessages([0, 2, 3]);
    setCompleted([]);

    let forceLogin = false;

    try {
      const res = await axios.post(`/api/centropaghe/anagrafica`, { step: 1 }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error, valido } = res.data;
      if (success) {
        if (!valido) {
          setMessages([0, 1, 2, 3]);
          forceLogin = true;
        }
        setCompleted([0]);
      } else {
        return closeWithError(error);
      }
    } catch (error) {
      return closeWithError("Si è verificato un errore sul nostro server.");
    }

    if (forceLogin) {
      try {
        const res = await axios.post(`/api/centropaghe/anagrafica`, { step: 2 }, {
          headers: utils.getAuthHeaders(),
        });
        const { success, error } = res.data;
        if (success) {
          setCompleted([0, 1]);
        } else {
          return closeWithError(error);
        }
      } catch (error) {
        return closeWithError("Si è verificato un errore sul nostro server.");
      }
    }

    try {
      const res = await axios.post(`/api/centropaghe/anagrafica`, { step: 3, idAssunzione }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setCompleted([0, 1, 2]);
      } else {
        return closeWithError(error);
      }
    } catch (error) {
      return closeWithError("Si è verificato un errore sul nostro server.");
    }

    try {
      const res = await axios.post(`/api/centropaghe/anagrafica`, { step: 4, idAssunzione }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error, missing } = res.data;
      if (success) {
        setLoading(false);
        if (missing.length) {
          return setMissingFields(missing);
        } else {
          setCompleted([0, 1, 2, 3]);
          setIsError(false);
          setStatusMessage("Anagrafica inserita con successo. Si prega di controllarla, inserire il titolo di studio e convalidare la creazione su Centro Paghe.")
        }
      } else {
        return closeWithError(error);
      }
    } catch (error) {
      return closeWithError("Si è verificato un errore sul nostro server.");
    }
  };

  const handleChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleContinue = async () => {
    setLoading(true);
    setMissingFields([]);

    try {
      const res = await axios.post(`/api/centropaghe/anagrafica`, { step: 4, idAssunzione, missing: formData }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error, missing } = res.data;
      if (success) {
        setLoading(false);
        if (missing.length) {
          return setMissingFields(missing);
        } else {
          setCompleted([0, 1, 2, 3]);
          setIsError(false);
          setStatusMessage("Anagrafica inserita con successo. Si prega di controllarla, inserire il titolo di studio e convalidare la creazione su Centro Paghe.")
        }
      } else {
        return closeWithError(error);
      }
    } catch (error) {
      return closeWithError("Si è verificato un errore sul nostro server.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Inserisci Anagrafica</DialogTitle>
      <DialogContent>
        {!loading && missingFields.length === 0 && (
          <Box display="flex" justifyContent="center" m={1}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleInsertAnagrafica}
            >
              Inserisci Anagrafica
            </Button>
          </Box>
        )}
        {(loading || completed.length > 0) && (
          <Box display="flex" flexDirection="column" alignItems="center">
            {loading && <CircularProgress />}
            {messages.map((index) => (
              <FormControlLabel
                key={index}
                control={
                  <Checkbox
                    checked={completed.includes(index)}
                    icon={<span />}
                    checkedIcon={<Check style={{ color: 'green' }} />}
                  />
                }
                label={messageTexts[index]}
              />
            ))}
          </Box>
        )}
        {missingFields.length > 0 && (
          <Box>
            {missingFields.map((field) => (
              <TextField
                key={field}
                autoFocus
                margin="dense"
                label={field.split('_').join(' ')}
                fullWidth
                onChange={handleChange(field)}
              />
            ))}
            <Typography color="error" style={{ fontWeight: 'bold', textAlign: 'center', margin: '10px' }}>
              Completare campi mancanti
            </Typography>
            <Box display="flex" justifyContent="center" m={2}>
              <Button onClick={handleContinue} color="primary" variant="contained">
                Continua
              </Button>
            </Box>
          </Box>
        )}
        {statusMessage && (
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              mt: 2,
              mb: 2,
              backgroundColor: isError ? "#e57373" : "#81c784",
              borderColor: isError ? "#d32f2f" : "#388e3c",
              color: "black",
            }}
            role="alert"
          >
            {statusMessage}
          </Paper>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Chiudi
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogCp;
